import { useEffect, useState } from "react";
import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { jalali_to_gregorian } from "../../env";

function StyleDatePickerSingle(props) {
  props.defaultValue && props.defaultValue.split("/");
  const defDate = {
    year: props.defaultValue && props.defaultValue.split("/")[0],
    month: props.defaultValue && props.defaultValue.split("/")[1],
    day: props.defaultValue && props.defaultValue.split("/")[2],
  };
  const [selectedDate, setSelectedDate] = useState(defDate);
  // const changeDate = () => {
  //   props.action(selectedDate ? selectedDate : "");
  // };
  // useEffect(() => {
  //   if (selectedDate) changeDate();
  //   else setSelectedDate(defDate);
  // }, [selectedDate, defDate]);
  // const changeDate = () => {
  //   props.action(selectedDate ? selectedDate : "");
  // };
  // useEffect(() => {
  //   if (selectedDate) changeDate();
  // }, [selectedDate]);
  return (
    <DatePicker
      value={selectedDate || ""}
      onChange={setSelectedDate}
      inputPlaceholder={props.title}
      shouldHighlightWeekends
      locale="fa" // add this
    />
  );
}
export default StyleDatePickerSingle;
